export const BLACK = '#000000'
export const WHITE = '#ffffff'
